import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { LoginService } from '../services/authentication/login.service';

@Injectable({ providedIn: 'root' })
export class HomeRedirectGuardService {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly loginService: LoginService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.userService.isAdmin()) {
      if (state.url == '/home') {
        this.router.navigate(['/administrator']);
      }
      return true;
    } else if (this.userService.isAdministrator()) {
      if (state.url == '/home') {
        this.router.navigate(['/administrator']);
      }
    } else if (this.userService.isReferencer()) {
      if (state.url == '/home') {
        this.router.navigate(['/referencer/home']);
      }
      return true;
    } else if (this.userService.isContributor()) {
      if (state.url == '/home') {
        this.router.navigate(['/contributor/home']);
      }
      return true;
    } else if (this.userService.isContributorV2()) {
      if (state.url == '/home') {
        this.router.navigate(['/contributorV2/home']);
      }
      return true;
    } else if (this.userService.isSuperAdmin()) {
      if (state.url == '/home') {
        this.router.navigate(['/dashboard']);
      }
      return true;
    } else if (this.userService.isTracker()) {
      if (state.url == '/home') {
        this.router.navigate(['/tracker/home']);
      }
      return true;
    } else if (this.userService.isValidator()) {
      if (state.url == '/home') {
        this.router.navigate(['/validator/home']);
      }
      return true;
    } else if (this.userService.isTechnicalAdministrator()) {
      if (state.url == '/home') {
        this.router.navigate(['/validator/home']);
      }
      return true;
    } else {
      this.loginService.landingPage = state.url;
      this.router.navigate(['/account/login']);
      return false;
    }
  }
}
